import "./src/styles/index.scss";

import { ToggleWrapper } from "@lg-cfa/components";
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { RecoilRoot } from "recoil";

import { RootLayout } from "./src/layouts/RootLayout";

// This function is used to wrap the root element of the application with necessary providers and layouts, and provide the rootlayout with i18n context.
// https://andremonteiro.pt/gatsby-i18next-wrap-page-element/
export const wrapPageElement = ({ element }) => {
    const newElement = React.cloneElement(
        element, // I18nextProvider
        element.props,
        React.cloneElement(
            element.props.children, // I18nextContext.Provider
            element.props.children.props,
            React.createElement(
                RootLayout,
                undefined,
                element.props.children.props.children,
            ),
        ),
    );

    return newElement;
};

export const wrapRootElement = ({ element }) => {
    return (
        <HelmetProvider>
            <RecoilRoot>
                <ToggleWrapper>{element}</ToggleWrapper>
            </RecoilRoot>
        </HelmetProvider>
    );
};
